import { paginationOptions, navigationOptions } from "Config/slider/default"
import { productsSliderOptions } from "Config/slider/products"
import { seenSliderOptions } from "Config/slider/seen"
import { accessoriesSliderOptions } from "Config/slider/accessories"
import { articleProductsSliderOptions } from "Config/slider/article-products"
import { indexBannerSliderOptions } from "Config/slider/index-banner"
import { indexBenefitsSliderOptions } from "Config/slider/index-benefits"
import { indexMonthSliderOptions } from "Config/slider/index-month"
import { dashboardProductsSlider } from "Config/slider/dashboard-products"
import { presentsSliderOptions } from "Config/slider/presents"


import { rSwiperVisibleItems } from 'Functions/swiper-visible-items'
import { rSwiperCssNavFix } from 'Functions/swiper-css-nav-fix'
import { Pagination, Navigation } from 'swiper';

export const sliderOptions = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        roundLengths: true,
        modules: [Pagination, Navigation, rSwiperVisibleItems, rSwiperCssNavFix]
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-products-slider')) {
        options = {...options, ...productsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-seen')) {
        options = {...options, ...seenSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-accessories')) {
        options = {...options, ...accessoriesSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-article-products')) {
        options = {...options, ...articleProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-banner-slider')) {
        options = {...options, ...indexBannerSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-index-benefits')) {
        options = {...options, ...indexBenefitsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-product-month')) {
        options = {...options, ...indexMonthSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-dashboard-products-slider')) {
        options = {...options, ...dashboardProductsSlider(instance, options)}
    }

    if (instance.hasAttribute('r-slider-presents')) {
        options = {...options, ...presentsSliderOptions(instance, options)}
    }

    return {...options, ...instance.customOptions}
}